// Where the app lands: the root route and every "take me home" fallback (unknown
// routes, a broken link, a finished sign-in). One place, so the default page
// changes in one edit.
export const HOME_PATH = "/dashboard";
